export default __webpack_public_path__ + "static/media/pic3.154c3fe4.jpg";